import { DateTime } from 'luxon'
import React from 'react'
import $ from 'jquery'
import { connect } from 'react-redux'
import { getMetrics, setLoading, setMetricData } from '../../../features/metric/metricSlice'
import processor from '../../../features/metric/processor'
import { appendModel, topOrgChange, orgChange, periodChange, regChange, siteChange, tokenChange } from '../../../features/site/siteSlice'

const DEFAULT_PROPS = {
    overrideCurrentMonth: false,
    overrideCurrentDay: false,
    fullMonthPeriods: false,
    fullYearPeriods: false,
    overrideOnSelection: false,
    showLastNMonths: false,
    onSelectionBegin: false,
    orgAsTopOrg: false,
    hideInputs: {
        organization: false,
        region: false,
        site: false,
        period: false
    },
    fixedPeriodTop: false,
    getPrevStorage: false,
    toggleSalesToken: false
}

class HierarchySelection extends React.Component{
    constructor(props){

        super(props)

        this.onSelection = this.onSelection.bind(this)
        this.onSelectChange = this.onSelectChange.bind(this)
        this.adjustPeriods = this.adjustPeriods.bind(this)
    }

    adjustPeriods(numberOfMonths, overrideCurrentMonth=false, overrideCurrentDay=false){
        if(numberOfMonths >= 1){
            let periods = []
            let startIdx = 0

            let dt = DateTime.local()
            let fillPeriodObj = (i, y1, m1, d1, y2, m2, d2) => {
                const startDate = DateTime.fromObject({year:y1, month: m1, day: d1})
                const endDate = DateTime.fromObject({year:y2, month: m2, day: d2})

                return { 
                    id: i,
                    start: startDate.setLocale("en-US").toLocaleString({month: 'short', day: 'numeric', year: '2-digit'}),
                    startISO: startDate.toISODate(),
                    end: endDate.setLocale("en-US").toLocaleString({month: 'short', day: 'numeric', year: '2-digit'}),
                    endISO: endDate.toISODate(),
                }
            }
            
            if(overrideCurrentMonth){
                if(!overrideCurrentDay){
                    dt = dt.endOf("month")
                }
                periods.push(fillPeriodObj(0, parseInt(dt.toFormat("yyyy")), parseInt(dt.toFormat("M")), 1, parseInt(dt.toFormat("yyyy")), parseInt(dt.toFormat("M")), parseInt(dt.toFormat("d"))))
                startIdx = 1
            } else if(!this.props.fullMonthPeriods && !this.props.fullYearPeriods) {
                periods.push(fillPeriodObj(
                    0, 
                    parseInt(dt.minus({days: 1, months: 1}).toFormat("yyyy")), 
                    parseInt(dt.minus({days: 1, months: 1}).toFormat("M")), 
                    parseInt(dt.minus({days: 1, months: 1}).toFormat("d")), 
                    parseInt(dt.minus({days: 1}).toFormat("yyyy")), 
                    parseInt(dt.minus({days: 1}).toFormat("M")), 
                    parseInt(dt.minus({days: 1}).toFormat("d"))
                ))
                startIdx = 1
            }

            for (let i=0; i<numberOfMonths; i++) {
                dt = dt.minus({month: 1}).endOf("month")
                periods.push(fillPeriodObj(i+startIdx, parseInt(dt.toFormat("yyyy")), parseInt(dt.toFormat("M")), 1, parseInt(dt.toFormat("yyyy")), parseInt(dt.toFormat("M")), parseInt(dt.toFormat("d"))))
            }

            this.props.appendModel({periods})
        }

    }

    async onSelectChange(e, customFunction, type){
        let value = e.target.value

        const { onSelectionBegin, model, orgAsTopOrg, trialMode } = this.props

        if(onSelectionBegin){
            let tbls = $.fn.dataTable.tables(true);
            $(tbls).each(function () {
                $(this).DataTable().destroy();

                if(trialMode){
                    $(this).DataTable().buttons().disable()
                }
            });
            if(trialMode){
                $(".dt-buttons.btn-group button").prop('disabled', true)
            }

            onSelectionBegin()
        }

        await customFunction(value)
    }
    
    async componentDidUpdate(prevProps, prevState){
        if(prevProps.siteStatus === "loading" && 
        this.props.siteStatus === "fulfilled"){
            this.props.model.abortController?.abort()
            await this.props.appendModel({
                abortController: new AbortController()
            })
            await this.onSelection()
            
        }

        const { onSelectionBegin, model, trialMode, orgAsTopOrg } = this.props

        if(prevProps.toggleSalesToken !== this.props.toggleSalesToken){
            if(this.props.toggleSalesToken && model.tokenActiveIdx !== -1){
                let value = model.tokenActiveIdx

                if(onSelectionBegin){
                    let tbls = $.fn.dataTable.tables(true);
                    $(tbls).each(function () {
                        $(this).DataTable().destroy();

                        if(trialMode){
                            $(this).DataTable().buttons().disable()
                        }
                    });
                    if(trialMode){
                        $(".dt-buttons.btn-group button").prop('disabled', true)
                    }

                    onSelectionBegin()
                }

                await this.props.onTokenChange(value)
            } else if(!this.props.toggleSalesToken && model.orgActiveIdx !== -1){
                let orgCustomFunc = this.props.onOrgChange
                let value = model.orgActiveIdx

                if(orgAsTopOrg){
                    orgCustomFunc = this.props.onTopOrgChange
                }

                if(onSelectionBegin){
                    let tbls = $.fn.dataTable.tables(true);
                    $(tbls).each(function () {
                        $(this).DataTable().destroy();

                        if(trialMode){
                            $(this).DataTable().buttons().disable()
                        }
                    });
                    if(trialMode){
                        $(".dt-buttons.btn-group button").prop('disabled', true)
                    }

                    onSelectionBegin()
                }

                await orgCustomFunc(value)
            }
        }

        if(prevProps.showLastNMonths !== this.props.showLastNMonths){
            if(this.props.showLastNMonths && this.props.showLastNMonths >= 1){
                this.adjustPeriods(this.props.showLastNMonths, this.props.overrideCurrentMonth, this.props.overrideCurrentDay)                
            }
        } else if(prevProps.fullMonthPeriods !== this.props.fullMonthPeriods){
            this.adjustPeriods(this.props.showLastNMonths || 7, this.props.overrideCurrentMonth, this.props.overrideCurrentDay)
        } else if(prevProps.fullYearPeriods !== this.props.fullYearPeriods){
            this.adjustPeriods(this.props.showLastNMonths || 7, this.props.overrideCurrentMonth, this.props.overrideCurrentDay)
        } else if(prevProps.fullYearPeriods && 
            prevProps.fullMonthPeriods && 
            !this.props.fullYearPeriods && !this.props.fullMonthPeriod) {
            this.adjustPeriods(7)
        }
    }

    async componentDidMount(){
        const { model } = this.props
        if(parseInt(model.period) >= 0){
            const { onSelectionBegin } = this.props

            if(this.props.fullMonthPeriods){
                this.adjustPeriods(this.props.showLastNMonths || 7, this.props.overrideCurrentMonth, this.props.overrideCurrentDay)
            } else if(this.props.fullYearPeriods){
                this.adjustPeriods(this.props.showLastNMonths || 7, this.props.overrideCurrentMonth, this.props.overrideCurrentDay)
            } else if(!this.props.fullYearPeriods && !this.props.fullMonthPeriod) {
                this.adjustPeriods(7)
            }

            if(onSelectionBegin){
                onSelectionBegin()
            }
            this.props.model.abortController?.abort()
            await this.props.appendModel({
                abortController: new AbortController()
            })

            await this.onSelection()

        } else {

            if(this.props.fullMonthPeriods){
                this.adjustPeriods(this.props.showLastNMonths || 7, this.props.overrideCurrentMonth, this.props.overrideCurrentDay)
            } else if(this.props.fullYearPeriods){
                this.adjustPeriods(this.props.showLastNMonths || 7, this.props.overrideCurrentMonth, this.props.overrideCurrentDay)
            } else if(!this.props.fullYearPeriods && !this.props.fullMonthPeriod) {
                this.adjustPeriods(7)
            }
        }
    }

    componentWillUnmount(){
        this.adjustPeriods(7)    
    }

    async onSelection(){
        const { model } = this.props
        const site = model?.sites[model?.siteActiveIdx]

        const siteId = site?.siteId
        if(!this.props.fullYearPeriods){
            if(!model.periods[model.period]){
                this.props.appendModel({
                    period: model.periods.length - 1
                })
            }
        } else {
            if(!model.periodsByYear[model.period]){
                this.props.appendModel({
                    period: model.periodsByYear.length - 1
                })
            }
        }
        if(this.props.overrideOnSelection){

            this.props.setLoading(true)
    
            let start = ""
            let end = ""

            if(this.props.fullYearPeriods){
                start = model.periodsByYear[model.period] ? model.periodsByYear[model.period].start : model.periodsByYear[model.periodsByYear.length - 1].start
                end = model.periodsByYear[model.period] ? model.periodsByYear[model.period].end : model.periodsByYear[model.periodsByYear.length - 1].end
            } else {
                start = model.periods[model.period] ? model.periods[model.period].startISO : model.periods[model.periods.length - 1].startISO
                end = model.periods[model.period] ? model.periods[model.period].endISO : model.periods[model.periods.length - 1].endISO
            }
    
            let dataPath = `${siteId}/${start}/${end}`
            try {

                const result = await this.props.overrideOnSelection(dataPath, null, {
                    siteId,
                    startDate: start,
                    endDate: end
                })
                await this.props.onSelectionComplete(result)
            } catch(error) {
                console.error(error)

            }
            this.props.setLoading(false)


        } else {
            try {

                let startISO = model.periods[parseInt(model.period)].startISO
                let endISO = model.periods[parseInt(model.period)].endISO
                let keyPrimary = `${siteId}/${startISO}/${endISO}`
                let keySecondary = ""
                
                let apiCalls = [this.props.getMetrics({key: keyPrimary, nocache: false, override: this.props.getPrevStorage && (parseInt(model.period) + 1) < model.periods.length})
                    .then(res => {
                        if(res.error){
                            throw res.error
                            return
                        } else {
                            return processor(res.payload.current.data, keyPrimary, site)
                        }
                    })]
                
                if(this.props.getPrevStorage && (parseInt(model.period) + 1) < model.periods.length){
                    startISO = model.periods[parseInt(model.period) + 1].startISO
                    endISO = model.periods[parseInt(model.period) + 1].endISO
                    keySecondary = `${siteId}/${startISO}/${endISO}`

                    apiCalls.push(this.props.getMetrics({key: keySecondary, nocache: false})
                        .then(res => {
                            if(res.error){
                                throw res.error
                                return
                            } else {
                                return processor(res.payload.current.data, keySecondary, site)
                            }
                        }))
                }

                try {

                    Promise.all(apiCalls).then(async(apiRes) => {
                        let currMetrics = apiRes[0]
                        let prevMetrics = apiRes[1]
                        await this.props.onSelectionComplete({
                            currMetrics,
                            prevMetrics
                        })
                    }).catch(e => {throw e})
                } catch(e) {
                    console.log(e)
                }
            } catch(error) {
                console.error(error)

            }

            
        }
        
    }
    
    render(){           
        let { fixedPeriodTop, model, loading, siteStatus, fullMonthPeriods, showLastNMonths, hideInputs, fullYearPeriods, orgAsTopOrg, overrideCurrentMonth, toggleSalesToken } = this.props
        let disabled = (loading || siteStatus === "loading")
        let hideAllInputs = true
        let formStyle = {}

        let regionStyle = {}
        let siteStyle = {}

        Object.keys(DEFAULT_PROPS.hideInputs).forEach(i => {
            if(hideInputs[i] === undefined){
                hideAllInputs = false
                return
            }

            if(!hideInputs[i]){
                hideAllInputs = false
                return
            }
        })

        if(hideAllInputs){
            formStyle = {
                height: 0
            }
        }

        if(hideInputs.region && hideInputs.site && !hideInputs.period && !hideInputs.organization){
            regionStyle = {
                position: "absolute",
                top: "-9999px",
                left: "-9999px",
                width: 0,
                height: 0
            }

            siteStyle = {
                position: "absolute",
                top: "-9999px",
                left: "-9999px",
                width: 0,
                height: 0
            }
        }


        if(hideInputs.site && !hideInputs.region &&  !hideInputs.period && !hideInputs.organization){
            siteStyle = {
                position: "absolute",
                top: "-9999px",
                left: "-9999px",
                width: 0,
                height: 0
            }
        }

        let organizations = model.organizations
        let orgCustomFunc = this.props.onOrgChange
        if(orgAsTopOrg){
            organizations = model.topOrganizations
            orgCustomFunc = this.props.onTopOrgChange
        }
        

        return <>
            {disabled && <span id="spinnerLoading" className="spinner-border spinner-border-sm mr-2 pull-right" role="status" aria-hidden="true"></span>}
            <div style={formStyle}><form className="form-inline row no-print">
                {toggleSalesToken && <>
                    <label className={`col-sm-2 col-lg-1 col-12 mb-custom-2`}>Sales Tokens:</label>
                    {!model.tokenFixed && <select id="tokenDropdown" disabled={disabled} style={{width: "160px"}} onChange={(e) =>this.onSelectChange(e, this.props.onTokenChange)} 
                        className={`form-control col-sm-4 col-lg-2 col-12 mb-custom-2`} value={model.tokenActiveIdx}>
                            <option></option>
                            {model?.salesTokens?.map((item, idx) =>(
                                <option key={idx} value={idx}>{item.name}</option>
                            ))}
                    </select>}
                    {model.tokenFixed && <div className={`form-control col-sm-4 col-lg-2 col-12 mb-custom-2`}>
                        { model.salesTokens?.length > 0 && model.salesTokens[0].name }
                    </div>}
                </>}
                {!toggleSalesToken && <>
                    <label className={`${hideInputs.organization ? "invisible" : ""} col-sm-2 col-lg-1 col-12 mb-custom-2`}>{orgAsTopOrg ? "Organizations" : "Companies"}:</label>
                    {!model.orgFixed && <select id="orgDropdown" disabled={disabled} style={{width: "160px"}} onChange={(e) =>this.onSelectChange(e, orgCustomFunc, orgAsTopOrg ? "TOP_ORG": "ORG")} 
                    className={`${hideInputs.organization ? "invisible" : ""} form-control col-sm-4 col-lg-2 col-12 mb-custom-2`} value={orgAsTopOrg ? model.topOrgActiveIdx : model.orgActiveIdx}>
                        <option></option>
                        {organizations?.map((item, idx) =>(
                            <option key={idx} value={idx}>{item.name}</option>
                        ))}
                    </select>}
                    {model.orgFixed && <div className={`${hideInputs.organization ? "invisible" : ""} form-control col-sm-4 col-lg-2 col-12 mb-custom-2`}>
                        { organizations?.length > 0 && organizations[0].name }
                    </div>}
                    
                    <label style={{...regionStyle}} className={`${hideInputs.region ? "invisible" : ""} col-sm-2 col-lg-1 col-12 mb-custom-2`}>Region:</label>
                    {!model.regFixed && <select disabled={disabled} style={{minWidth: "100px", ...regionStyle}} onChange={(e) =>this.onSelectChange(e, this.props.onRegChange)} 
                        className={`${hideInputs.region ? "invisible" : ""} form-control col-sm-4 col-lg-2 col-12 mb-custom-2`} 
                        value={model.regActiveIdx}>
                        {model?.regions?.map((item, idx) =>(
                            <option key={idx} value={idx}>{item.name}</option>
                        ))}
                    </select>}
                    {model.regFixed && <div style={regionStyle} className={`${hideInputs.region ? "invisible" : ""} form-control col-sm-4 col-lg-2 col-12 mb-custom-2`}>
                        { model.regions.length > 0 && model.regions[0].name }
                    </div>}

                    <label style={{...siteStyle}} className={`${hideInputs.site ? "invisible" : ""} col-sm-2 col-lg-1 col-12 mb-custom-2`}>Site:</label>
                    {!model.siteFixed && <select id="siteDropdown" disabled={disabled} style={{minWidth: "125px", ...siteStyle}} onChange={(e) =>this.onSelectChange(e, this.props.onSiteChange)} 
                        className={`${hideInputs.site ? "invisible" : ""} form-control col-sm-4 col-lg-2 col-12 mb-custom-2 site-select`}
                        value={model.siteActiveIdx}>
                        {model.sites?.map((item, idx) =>(
                            <option key={idx} value={idx}>{item.name}</option>
                        ))}
                    </select>}
                    {model.siteFixed && <div style={{minWidth: "125px", ...siteStyle}} className={`${hideInputs.site ? "invisible" : ""} form-control col-sm-4 col-lg-2 col-12 mb-custom-2 site-select`}>
                        { model.sites.length > 0 && model.sites[0].name }
                    </div>}

                </>}
                <label className={`${hideInputs.period ? "invisible" : ""} col-sm-2 col-lg-1 col-12 mb-custom-2`}>Period:</label>
                {!fixedPeriodTop && <select disabled={disabled} onChange={(e) =>this.onSelectChange(e, this.props.onPeriodChange)} 
                    className={`${hideInputs.period ? "invisible" : ""} form-control periods-select col-sm-4 col-lg-2 col-12 mb-custom-2`}
                    value={parseInt(model.period)}>
                    {!fullMonthPeriods && fullYearPeriods ? model.periodsByYear?.map(item =>(
                        <option key={item.id} value={item.id}>{item.start+' - '+item.end}</option>
                    )) : model.periods?.map(item =>(
                        <option key={item.id} value={item.id}>{item.start+' - '+item.end}</option>
                    ))}
                </select>}
                {fixedPeriodTop && <div style={{minWidth: "125px", ...siteStyle}} className={`${hideInputs.period ? "invisible" : ""} periods-select form-control col-sm-4 col-lg-2 col-12 mb-custom-2`}>
                    {!fullMonthPeriods && fullYearPeriods && model?.periodsByYear?.length > 0 ? model.periodsByYear[0].start+' - '+model.periodsByYear[0].end : 
                model?.periods?.length > 0 ? model.periods[0].start+' - '+model.periods[0].end : ""}
                </div>}

            </form><br /></div>
        </>
    }
}

HierarchySelection.defaultProps = {
    ...DEFAULT_PROPS
}

const mapStateToProps = (state) => ({
    model: state.site.model,
    loading: state.metric.loading,
    siteStatus: state.site.status,
    session: state.session
})

const mapDispatchToProps = (dispatch) => ({
    onOrgChange: (idx) => dispatch(orgChange(idx)),
    onTopOrgChange: (idx) => dispatch(topOrgChange(idx)),
    onRegChange: (idx) => dispatch(regChange(idx)),
    onSiteChange: (idx) => dispatch(siteChange(idx)),
    onPeriodChange: (idx) => dispatch(periodChange(idx)),
    getMetrics: (details) => dispatch(getMetrics(details)),
    setMetricData: (details) => dispatch(setMetricData(details)),
    appendModel: (payload) => dispatch(appendModel(payload)),
    setLoading: (payload) => dispatch(setLoading(payload)),
    onTokenChange: (payload) => dispatch(tokenChange(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(HierarchySelection)